export const MANAGE_TAGS = 'MANAGE_TAGS';
export const DELETE_TAG_SUCCESS = 'DELETE_TAG_SUCCESS';
export const EDIT_TAG_SUCCESS = 'EDIT_TAG_SUCCESS';
export const ADD_NEW_TAG_SUCCESS = 'ADD_NEW_TAG_SUCCESS';
export const GET_SELLER_TAGS_SUCCESS = 'GET_SELLER_TAGS_SUCCESS';
export const GET_SELLER_TAGS = 'GET_SELLER_TAGS';

export const manageTags = () => {
  return {
    type: MANAGE_TAGS,
  };
};

export const addNewTagSuccess = (tags) => {
  return {
    type: ADD_NEW_TAG_SUCCESS,
    tags,
  };
};

export const deleteTagSuccess = ({ tagId }) => {
  return {
    type: DELETE_TAG_SUCCESS,
    tagId,
  };
};

export const editTagSuccess = ({ tag }) => {
  return {
    type: EDIT_TAG_SUCCESS,
    tag,
  };
};

export const FULFILLMENT_PLANS_BULK_ADD_TAGS_REQUEST = 'FULFILLMENT_PLANS_BULK_ADD_TAGS_REQUEST';
export const bulkAddFulfillmentPlanTags = (fulfillmentPlanIds, tagIds, errorCallback) => ({
  type: FULFILLMENT_PLANS_BULK_ADD_TAGS_REQUEST,
  fulfillmentPlanIds,
  tagIds,
  errorCallback,
});

export const FULFILLMENT_PLANS_BULK_REMOVE_TAGS_REQUEST = 'FULFILLMENT_PLANS_BULK_REMOVE_TAGS_REQUEST';
export const bulkRemoveFulfillmentPlanTags = (fulfillmentPlanIds, tagIds, errorCallback) => ({
  type: FULFILLMENT_PLANS_BULK_REMOVE_TAGS_REQUEST,
  fulfillmentPlanIds,
  tagIds,
  errorCallback,
});
export const getSellerTagsSuccess = (data) => {
  return {
    type: GET_SELLER_TAGS_SUCCESS,
    tags: data,
  };
};

export const getSellerTags = () => {
  return {
    type: GET_SELLER_TAGS,
  };
};
